
window.audioEventListeners = {};


const triggerTimeUpdateListener = (event) => {
    if (window.audioEventListeners.onTimeUpdateListener)
        window.audioEventListeners.onTimeUpdateListener(event);
};

const triggerCanPlayListener = (event) => {
    if (window.audioEventListeners.onCanPlayListener)
        window.audioEventListeners.onCanPlayListener(event);
};

const triggerPlayingListener = (event) => {
    if (window.audioEventListeners.onPlayingListener)
        window.audioEventListeners.onPlayingListener(event);
};

const triggerWaitingListener = (event) => {
    if (window.audioEventListeners.onWaitingListener)
        window.audioEventListeners.onWaitingListener(event);
};


export const GlobalAudioEventListeners = {
    attachElement: (audioElement) => {
        audioElement.addEventListener('canplay', triggerCanPlayListener, false);
        audioElement.addEventListener('timeupdate', triggerTimeUpdateListener, false);
        audioElement.addEventListener('playing', triggerPlayingListener, false);
        audioElement.addEventListener('waiting', triggerWaitingListener, false);

        console.log('Audio event listeners added!');
    },


    onTimeUpdate: (listener) => { window.audioEventListeners.onTimeUpdateListener = listener; },
    onCanPlay: (listener) => { window.audioEventListeners.onCanPlayListener = listener; },
    onPlaying: (listener) => { window.audioEventListeners.onPlayingListener = listener; },
    onWaiting: (listener) => { window.audioEventListeners.onWaitingListener = listener; },
    
    detachElement: (audioElement) => {
        audioElement.removeEventListener('canplay', triggerCanPlayListener);
        audioElement.removeEventListener('timeupdate', triggerTimeUpdateListener);
        audioElement.removeEventListener('playing', triggerPlayingListener);
        audioElement.removeEventListener('waiting', triggerWaitingListener);

        console.log('Audio event listeners removed!');
    }
};